module.exports = __webpack_public_path__ + "static/media/bluetooth.1ca1dea7.svg";